import React from 'react'
import { Link } from 'react-router-dom'
import { buildRoutePath, routes } from '../../constants/routes'
import { withRouterProps } from '../utils/with-router-props'

const AccountSidebar = ({ account, location }) => {
    const isActiveRoute = (routePath) => {
        return location.pathname === routePath
    }

    if (!account || !account.id) {
        return null
    }

    const navItems = [
        {
            path: buildRoutePath(routes.adminAccountView.path, { accountId: account.id }),
            label: 'Edit Account Details',
            key: 'account-details'
        },
        {
            path: buildRoutePath(routes.adminAccountDashboard.path, { accountId: account.id }),
            label: 'Current Installations',
            key: 'dashboard'
        },
        {
            path: buildRoutePath(routes.adminImeiIndex.path, { accountId: account.id }),
            label: 'Telematics (IMEIs)',
            key: 'imeis'
        },
        {
            path: buildRoutePath(routes.adminUsersIndex.path, { accountId: account.id }),
            label: 'List of Users',
            key: 'users'
        },
        {
            path: buildRoutePath(routes.adminUsersCreate.path, { accountId: account.id }),
            label: 'Create New User',
            key: 'create-user'
        }
    ]

    return (
        <div className="sidebar">
            <nav>
                {navItems.map((item) => {
                    const isActive = isActiveRoute(item.path)

                    return (
                        <Link
                            key={item.key}
                            to={item.path}
                            className={`nav-link ${isActive ? 'active' : ''}`}
                        >
                            {item.label}
                        </Link>
                    )
                })}
            </nav>
        </div>
    )
}

export default withRouterProps(AccountSidebar)
